import React from "react"
import {CmCollection, CollectionItem} from "../../../../packages/graphql-layer/src";
import C021KachelTeaser from "../../content/C021KachelTeaser/C021KachelTeaser";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";


export interface Props {
    otherContents: any[]
}

function P011PublicationOtherContent(props: Props) {
    const items: CollectionItem[] = [];
    props.otherContents.forEach(content => items.push(...content.items));
    return <CCOComponentWrapper
        key='other_content'
        fullWidthOnMobile
        customStyle={{minHeight: {xs: '250px', lg: '350px', xl: '400px'}}}
    >
        <C021KachelTeaser cmCollection={{items: items} as CmCollection}/>
    </CCOComponentWrapper>
}

export default P011PublicationOtherContent